import { useStore } from "@nanostores/preact"
import { profile, support } from "../services/store"
import { Currency, IsoCountry, Products, resolveUserPricing } from "../services/support"

export interface UserData {
  country: IsoCountry
  currency: Currency
  products: Products
}

export function useUserData(): UserData | null {
  const user = useStore(profile)
  const supportData = useStore(support)
  if (!supportData) return null

  return resolveUserPricing(
    supportData.iso_countries,
    supportData.currencies,
    supportData.products,
    user.countryIso,
    supportData.default_iso_country,
  )
}
